/* eslint-disable lines-between-class-members,dot-notation */
import BaseModel from '@kakadu-dev/base-frontend-helpers/models/BaseModel';
import { Company } from "../Companies";
import { Product, ProductOption } from "../Products";
import { Order } from "./Order";
import { OrderProductTag } from "./OrderProductTag";
import { allStatuses, allStatusesTypes, holdStates, holdStatesTypes, orderActions, orderActionsTypes, placements, placementsTypes, productPaymentMethods, productPaymentMethodsTypes } from "./statuses";
/**
 * Order product class
 */

export class OrderProduct extends BaseModel {
  constructor(...args) {
    super(...args);

    this.getId = () => {
      return this.model.id;
    };

    this.getPrice = () => {
      return this.model.price;
    };

    this.getCount = () => {
      return Number(this.model.count);
    };

    this.getStatus = (asLabel = false) => {
      return asLabel ? OrderProduct.statuses[this.model.status || 'unknown'] || OrderProduct.statuses['unknown'] : this.model.status;
    };

    this.getPaymentMethod = (asLabel = false) => {
      return asLabel ? OrderProduct.paymentMethods[this.model.paymentMethod || 'unknown'] || OrderProduct.paymentMethods['unknown'] : this.model.paymentMethod;
    };

    this.getActionType = (asLabel = false) => {
      return asLabel ? OrderProduct.orderActions[this.model.actionType || 'unknown'] || OrderProduct.orderActions['unknown'] : this.model.actionType;
    };

    this.getHoldState = (asLabel = false) => {
      return asLabel ? OrderProduct.holdStates[this.model.holdState || 'unknown'] || OrderProduct.holdStates['unknown'] : this.model.holdState;
    };

    this.getPlacement = (asLabel = false) => {
      return asLabel ? OrderProduct.placements[this.model.placementId || 'unknown'] || OrderProduct.placements['unknown'] : this.model.placementId;
    };

    this.getCreatedAt = () => {
      return this.model.createdAt;
    };

    this.getOrder = order => {
      return this.getRelation('order', Order, order);
    };

    this.getProduct = product => {
      return this.getRelation('product', Product, product);
    };

    this.getOrderProductTags = tags => {
      return this.getRelation('tags', OrderProductTag, tags, true);
    };

    this.getCompany = company => {
      return this.getRelation('company', Company, company);
    };

    this.getOption = option => {
      return this.getRelation('option', ProductOption, option);
    };
  }

  /**
   * Create order product
   *
   * @param {object} object
   *
   * @return {OrderProduct}
   */
  static create(object) {
    return super.create(object);
  }
  /**
   * Create list order products
   *
   * @param {object} objects
   *
   * @return {Array.<OrderProduct>}
   */


  static createList(objects) {
    return super.createList(objects);
  }
  /**
   * Map order products
   *
   * @param {Array.<object>} objects
   * @param {function(OrderProduct): undefined} callback
   *
   * @return {Array.<object>}
   */


  static map(objects, callback) {
    return super.map(objects, callback);
  }
  /**
   * Get order product id
   *
   * @return {number}
   */


}
OrderProduct.statuses = allStatuses;
OrderProduct.statusesTypes = allStatusesTypes;
OrderProduct.paymentMethods = productPaymentMethods;
OrderProduct.paymentMethodsTypes = productPaymentMethodsTypes;
OrderProduct.orderActions = orderActions;
OrderProduct.orderActionsTypes = orderActionsTypes;
OrderProduct.holdStates = holdStates;
OrderProduct.holdStatesTypes = holdStatesTypes;
OrderProduct.placements = placements;
OrderProduct.placementsTypes = placementsTypes;